import { create } from "zustand";

interface FiltersState {
  when: "all" | "today" | "weekend";
  price: "all" | "free" | "paid" | "unknown";
  category: string | null;
  districts: string[];
  organizationIds: string[];
  search: string;
  // Señaliza que el bootstrap de filtros desde la URL (?category=, etc., ver
  // UrlFiltersBootstrap) ya corrió — vive acá (no como estado local de
  // /eventos) porque ese bootstrap necesita useSearchParams(), que obliga a
  // aislarlo en su propio componente con Suspense para no forzar a todo
  // /eventos a bailoutear del renderizado estático/servidor. El store
  // desacopla ambos componentes sin necesidad de que sean padre-hijo.
  bootstrapDone: boolean;
  setWhen: (v: "all" | "today" | "weekend") => void;
  setPrice: (v: "all" | "free" | "paid" | "unknown") => void;
  setCategory: (v: string | null) => void;
  setDistricts: (v: string[]) => void;
  setOrganizationIds: (v: string[]) => void;
  setSearch: (v: string) => void;
  setBootstrapDone: (v: boolean) => void;
  resetFilters: () => void;
}

export const useFiltersStore = create<FiltersState>((set) => ({
  when: "all",
  price: "all",
  category: null,
  districts: [],
  organizationIds: [],
  search: "",
  bootstrapDone: false,
  setWhen: (when) => set({ when }),
  setPrice: (price) => set({ price }),
  setCategory: (category) => set({ category }),
  setDistricts: (districts) => set({ districts }),
  setOrganizationIds: (organizationIds) => set({ organizationIds }),
  setSearch: (search) => set({ search }),
  setBootstrapDone: (bootstrapDone) => set({ bootstrapDone }),
  resetFilters: () => set({ when: "all", price: "all", category: null, districts: [], organizationIds: [], search: "" }),
}));
